export default {
  name: {
    presence: { allowEmpty: false }
  }
};
